
exports.BarChart = require('./BarChart');



//////////////////
// WEBPACK FOOTER
// ./~/react-d3/barchart/index.js
// module id = 336
// module chunks = 0